var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllImgVideoInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_162)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_758_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24L24 24L24 0L0 0L0 24Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_758_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.488 23.889H21.4C22.06 23.8885 22.6927 23.6261 23.1594 23.1594C23.6261 22.6927 23.8885 22.06 23.889 21.4V2.488C23.8882 1.82821 23.6257 1.19569 23.159 0.729242C22.6924 0.262795 22.0598 0.00052926 21.4 0L2.488 0C1.82838 0.000793921 1.19601 0.263177 0.729595 0.729595C0.263177 1.19601 0.000793921 1.82838 0 2.488L0 21.4C0.00052926 22.0598 0.262795 22.6924 0.729242 23.159C1.19569 23.6257 1.82821 23.8882 2.488 23.889ZM1.988 21.401V12.94H10.946V21.9H2.488C2.35591 21.8992 2.2295 21.8462 2.13638 21.7525C2.04326 21.6588 1.991 21.5321 1.991 21.4L1.988 21.401ZM21.397 21.901H12.94V12.94H21.9V21.4C21.9 21.5326 21.8473 21.6598 21.7536 21.7536C21.6598 21.8473 21.5326 21.9 21.4 21.9L21.397 21.901ZM21.897 2.491V10.952H12.94V1.991H21.4C21.5321 1.991 21.6588 2.04326 21.7525 2.13638C21.8462 2.2295 21.8992 2.35591 21.9 2.488L21.897 2.491ZM2.487 1.991H10.948V10.949H1.991V2.488C1.99179 2.35643 2.0444 2.23047 2.13744 2.13744C2.23047 2.0444 2.35543 1.99179 2.487 1.991Z",
    fill: "#7B7B7B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllImgVideoInactive);
export default __webpack_public_path__ + "static/media/all-img-video-inactive.e5cff17a83bee2924f09319297f00f77.svg";
export { ForwardRef as ReactComponent };